"use client"

import { useState } from "react"
import { motion, AnimatePresence } from "framer-motion"
import { FaWhatsapp } from "react-icons/fa"
import { siteConfig } from "@/config/site"
import Link from "next/link"

export function WhatsAppButton() {
  const [isHovered, setIsHovered] = useState(false)

  const whatsappNumber = siteConfig.links.whatsapp.replace(/\s/g, "")
  const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent("Merhaba, hizmetleriniz hakkında bilgi almak istiyorum.")}`

  return (
    <motion.div
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ type: "spring", stiffness: 260, damping: 20, delay: 0.5 }}
      className="fixed bottom-20 right-6 z-[100]"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <Link
        href={whatsappUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="flex items-center gap-3 bg-[#25D366] hover:bg-[#20BA5A] text-white rounded-full shadow-lg hover:shadow-xl transition-all duration-300 group overflow-hidden"
        aria-label="WhatsApp ile iletişime geç"
      >
        <div className="flex items-center justify-center w-14 h-14 p-3">
          <FaWhatsapp className="h-8 w-8 text-white" />
        </div>
        <AnimatePresence>
          {isHovered && (
            <motion.span
              initial={{ width: 0, opacity: 0 }}
              animate={{ width: "auto", opacity: 1 }}
              exit={{ width: 0, opacity: 0 }}
              transition={{ duration: 0.2 }}
              className="pr-4 text-sm font-medium whitespace-nowrap"
            >
              WhatsApp
            </motion.span>
          )}
        </AnimatePresence>
      </Link>
    </motion.div>
  )
}

